<template>
  <div>
    <transition name="fade" mode="out-in" >
    <div v-if="sendToOther == false" key="sign">
        <h3>Sign for {{business}}</h3>

        <p>Please continue to enter your information and provide a digital signature.</p>
        <Checkbox :inputField="inputs.smsConsent" inputName="SMS Consent" inputType="required">
        I agree to the
        <a href="/application-agreement/" target="_blank">Cardiff Application Agreement</a> and
        <a href="/e-sign-consent/" target="_blank">E-Sign Consent Agreement</a>.
        </Checkbox>
        <div class="buttons is-right">
        <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
            <a class="button is-link padded-button next-button" @click="next">Continue</a>
        </div>
        <!-- <hr>
        <p>Not the co-signer? Click below to email this form to someone else.</p>
        <div class="buttons is-right">
            <a
                class="button is-link is-inverted padded-button next-button"
                @click="sendToOther = true"
            >Send to Co-Signer</a>
        </div> -->
    </div>
    <div v-else key="signer">
        <h3>Sign for {{business}}</h3>
        <p>Send a link to your co-signer.</p>
        <Input @enter="next" :inputField="inputs.otherName" inputName="Signer Name" inputType="string"/>
        <Input @enter="next" :inputField="inputs.otherEmail" inputName="Signer Email" inputType="email" :icons='{right: "fa-envelope"}'/>
        <div class="buttons is-right">
        <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
            <a class="button is-link padded-button next-button" @click="next">Send</a>
        </div>
        <div class="buttons is-right">
        <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
            <a
                class="button is-link is-inverted padded-button next-button"
                @click="sendToOther = false"
            >Cancel</a>
        </div>
    </div>
    </transition>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import Checkbox from "@/components/shared/Checkbox";
import ApplyPage from "@/components/shared/ApplyPage";
import $ from "jquery";
export default {
  name: "Breifing",
  components: { Checkbox, Input },
  props: {
    business: String,
    pgname: String
  },
  mixins: [ApplyPage],
  data() {
    return {
      obj: "pg",
      inputs: {
        smsConsent: Input.model(),
        otherName: Input.model(),
        otherEmail: Input.model()
      },
      sendToOther: false
    };
  },
  methods: {
    send() {
      
    }
  },
  mounted: function() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
